import Vue from 'vue'
import Router from 'vue-router'
import routerHook from './routerHook.js'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import(/* webpackChunkName: "home" */ '../views/main.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/getcoupon',
    name: 'getcoupon',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/getcoupon.vue')
  },
  {
    path: '/open',
    name: 'open',
    component: () => import(/* webpackChunkName: "home" */ '../views/open.vue')
  },
  {
    path: '/active',
    name: 'active',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/active.vue')
  },
  {
    path: '/record',
    name: 'record',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/record.vue')
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/exchange.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const __router = new Router({
  base: '/web-carpoolinvite',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

routerHook(__router)
export default __router
